/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */
export function csFlip(i) {
  // flip the value
  return -i - 2;
}


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/function/algebra/sparse/csFlip.js
// module id = SuRC
// module chunks = 3